interface IInfoArea {
    title: string,
    value: string[],
    row: number
}

const InfoAreaMulti = ({ title, value, row }: IInfoArea) => {
    return (
        <div className={`flex ${row === 1 ? 'items-center' : 'items-start'} tablet:flex-col tablet:items-start`}>
            <p className='w-[150px] text-lg shrink-0'>{title}</p>

            <div className="flex flex-col gap-6 min-w-[600px] tablet:min-w-[100%]">
                {
                    Array(row).fill(null).map((_, idx) => (
                        <div
                            className='bg-[#F8F8FA] px-6 py-3 rounded min-h-12'
                            key={idx}
                            dangerouslySetInnerHTML={{ __html: value[idx] }}>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default InfoAreaMulti